import React from "react";

export function highlightGoldCoast(text) {
  if (!text) return text;
  return String(text).split(/(Gold Coast)/g).map((part, index) =>
    part === "Gold Coast" ? (
      <span key={index} className="gc">
        {part}
      </span>
    ) : (
      part
    )
  );
}
